const getters = {
  getBusinessDevelopers: state => state.businessDevelopers
}

const actions = {
  setBusinessDevelopers ({ commit }, data) {
    commit('setBusinessDevelopers', data)
  }
}

const mutations = {
  setBusinessDevelopers (state, data) {
    state.businessDevelopers = data
  }
}

const state = {
  businessDevelopers: []
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
